import PropTypes from "prop-types";

import { CampusEnvironmentCard as CommonCampusEnvironmentCard } from "../../../../core/compose/cards";

function CampusEnvironmentCard({
  id,
  open,
  chosenSchool,
  externalToggle,
  callbackToggle,
}) {
  return (
    <CommonCampusEnvironmentCard
      id={id}
      open={open}
      chosenSchool={chosenSchool}
      externalToggle={externalToggle}
      callbackToggle={callbackToggle}
    />
  );
}

CampusEnvironmentCard.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  externalToggle: PropTypes.bool,
  callbackToggle: PropTypes.func,
  chosenSchool: PropTypes.shape(),
};

export default CampusEnvironmentCard;
